import React, { useReducer, createContext } from "react";
import { bookReducer, bookInitialState } from "../reducers";
import constant from "../constants/bookConstant";
import { bookService } from "../services";
import { toast } from "react-toastify"
import { history } from "../tools";

export const BookContext = createContext();

export const BookContextProvider = (props) => {

    const [state, dispatch] = useReducer(bookReducer, bookInitialState);

    const get = (id, isRequest = true) => {

        if (isRequest) {

            dispatch(request());
        }

        bookService.get(id).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));
            }).
            catch(ex => {

                toast.error("the book couldn't be fetched!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.GET_SUCCESS, payload: data }; }
        function fail() { return { type: constant.GET_FAIL }; }
        function request() { return { type: constant.GET_REQUEST }; }
    };

    const add = (book, onSuccess) => {

        dispatch(request());

        bookService.add(book).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));

                if (onSuccess) {

                    onSuccess(response.data);
                }
            }).
            catch(ex => {

                toast.error("the book couldn't be added!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.ADD_SUCCESS, payload: data }; }
        function fail() { return { type: constant.ADD_FAIL }; }
        function request() { return { type: constant.ADD_REQUEST }; }
    };

    const should = (dto, onSuccess) => {

        dispatch(request());

        bookService.should(dto).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));

                if (onSuccess) {

                    onSuccess();
                }
            }).
            catch(ex => {

                toast.error("the book couldn't be rated!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.SHOULD_SUCCESS, payload: data }; }
        function fail() { return { type: constant.SHOULD_FAIL }; }
        function request() { return { type: constant.SHOULD_REQUEST }; }
    };

    const addReadList = (dto, onSuccess) => {

        dispatch(request());

        bookService.addReadList(dto).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));

                if (onSuccess) {

                    onSuccess();
                }
            }).
            catch(ex => {

                toast.error("The book couldn't be added to your reading list!");

                dispatch(fail("!"));
            });

        function request() { return { type: constant.ADD_LIST_REQUEST }; }
        function success(data) {
            return { type: constant.ADD_LIST_SUCCESS, payload: data };
        }
        function fail() { return { type: constant.ADD_LIST_FAIL }; }
    };

    const searchAuthor = (key) => {

        dispatch(request());
        
        bookService.searchAuthor(key).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));
            }).
            catch(ex => {

                toast.error("authors couldn't be fetched!");

                dispatch(fail("!"));
            });

        function success(data) {
            return { type: constant.SEARCH_AUTHOR_SUCCESS, payload: data };
        }
        function fail() { return { type: constant.SEARCH_AUTHOR_FAIL }; }
        function request() { return { type: constant.SEARCH_AUTHOR_REQUEST }; }
    };

    const search = (key, isRequest = true) => {

        if (isRequest) {

            dispatch(request());
        }

        bookService.search(key).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));
            }).
            catch(ex => {

                toast.error("books couldn't be fetched!");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.SEARCH_SUCCESS, payload: data }; }
        function fail() { return { type: constant.SEARCH_FAIL }; }
        function request() { return { type: constant.SEARCH_REQUEST }; }
    };

    const goToDetail = (id) => {

        history.push("/book/" + id)
    }

    const reset = () => {

        dispatch({ type: constant.RESET })
    }

    const paginate = (dto, onSuccess) => {

        dto = { ...{ limit: 12 }, ...dto };

        dispatch(request());

        bookService.paginate(dto).
            then(response => {

                if (!response.success) {

                    toast.error(response.message);

                    dispatch(fail());

                    return;
                }

                dispatch(success(response.data));

                if (onSuccess) {

                    onSuccess();
                }
            }).
            catch(ex => {

                toast.error("books couldn't be fetched");

                dispatch(fail("!"));
            });

        function success(data) { return { type: constant.PAGINATE_SUCCESS, payload: data }; }
        function fail() { return { type: constant.PAGINATE_FAIL }; }
        function request() { return { type: constant.PAGINATE_REQUEST }; }
    };

    return (
        <BookContext.Provider value={[state,
            {
                add,
                search,
                paginate,
                searchAuthor,
                get,
                should,
                reset,
                addReadList,
                goToDetail
            }]}>
            {props.children}
        </BookContext.Provider>
    );
};

